// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubscribeBox_wrapper__2601L","borderColor":"SubscribeBox_borderColor__6cA33","title":"SubscribeBox_title__OaRWY"};